import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b883d8a")

_pushScopeId("data-v-4b883d8a")
const _hoisted_1 = { class: "m-frame" }
const _hoisted_2 = { class: "header-wrap" }
const _hoisted_3 = { class: "app-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "m-frame-iconfont icon-yingyong" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 删除应用 ")
const _hoisted_6 = { class: "main-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", { class: "menu-title" }, "应用导航", -1)
const _hoisted_8 = { class: "main-content" }
const _hoisted_9 = {
  key: 1,
  class: "no-login",
  style: {}
}
const _hoisted_10 = { class: "result-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_result = _resolveComponent("el-result")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLogin)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("section", _hoisted_2, [
            _createVNode("header", null, [
              _createVNode("h3", _hoisted_3, [
                _hoisted_4,
                _createVNode("i", null, _toDisplayString(_ctx.title), 1)
              ]),
              (_ctx.deleteApi)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    icon: "el-icon-delete",
                    onClick: _ctx.deleteApp,
                    loading: _ctx.delLoading
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("section", _hoisted_6, [
            _createVNode("aside", null, [
              _hoisted_7,
              _createVNode(_component_el_menu, {
                "default-active": _ctx.getRoute(_ctx.curPath),
                router: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routeList, (item) => {
                    return (_openBlock(), _createBlock(_Fragment, {
                      key: item.path
                    }, [
                      (item.children)
                        ? (_openBlock(), _createBlock(_component_el_submenu, {
                            key: 0,
                            index: _ctx.getRoute(item.path)
                          }, {
                            title: _withId(() => [
                              (item.iconClass)
                                ? (_openBlock(), _createBlock("i", {
                                    key: 0,
                                    class: 'nav-icon ' + item.iconClass
                                  }, null, 2))
                                : _createCommentVNode("", true),
                              _createVNode("span", null, _toDisplayString(item.title), 1)
                            ]),
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (child) => {
                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: child.path,
                                  index: child.path
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(child.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : _createCommentVNode("", true),
                      (!item.children)
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 1,
                            index: _ctx.getRoute(item.path)
                          }, {
                            title: _withId(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            default: _withId(() => [
                              (item.iconClass)
                                ? (_openBlock(), _createBlock("i", {
                                    key: 0,
                                    class: 'nav-icon ' + item.iconClass
                                  }, null, 2))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _createVNode("main", null, [
              _createVNode("div", _hoisted_8, [
                (_ctx.aliveInclude)
                  ? (_openBlock(), _createBlock(_component_router_view, { key: _ctx.refreshTag }, {
                      default: _withId(({ Component }) => [
                        (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.aliveInclude }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 1032, ["include"]))
                      ]),
                      _: 1
                    }))
                  : (_ctx.aliveExclude)
                    ? (_openBlock(), _createBlock(_component_router_view, { key: _ctx.refreshTag }, {
                        default: _withId(({ Component }) => [
                          (_openBlock(), _createBlock(_KeepAlive, { exclude: _ctx.aliveExclude }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                          ], 1032, ["exclude"]))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_router_view, { key: _ctx.refreshTag }))
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_el_result, {
              icon: "warning",
              title: "登录已过期",
              "sub-title": "请从应用中心重新登录！"
            })
          ])
        ]))
  ]))
})